import React from "react";

const PagePlaceholder = ({ title }) => <h1>{title}</h1>;

export default PagePlaceholder;
